import React from 'react';
import './ui.css';

/**
 * SubTabs — segmented control / sub-navigation within a page.
 * Props:
 *   tabs: [{ key, label, icon? }]
 *   value: active key
 *   onChange: (key) => void
 *   ariaLabel?: string
 */
export default function SubTabs({ tabs = [], value, onChange, ariaLabel }) {
  return (
    <div className="ui-subtabs" role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const active = tab.key === value;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`ui-subtabs__tab ${active ? 'ui-subtabs__tab--active' : ''}`}
            onClick={() => onChange?.(tab.key)}
          >
            {tab.icon && <span aria-hidden="true">{tab.icon}</span>}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
